require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/core-js/es6/parse-float.js
// module id = NzKl
// module chunks = 0